module.exports = __webpack_public_path__ + "img/index-share-ins.f73d6afc.png";